import { createContext } from 'react'
import { useAuthModal, ModalResult } from '.'

interface AuthModalContextType {
  startAuthModal: () => Promise<ModalResult>
}

export const AuthModalContext = createContext<AuthModalContextType>({ startAuthModal: async () => undefined })

const AuthModalProvider: React.FC = ({ children }) => {
  const startAuthModal = useAuthModal()

  return <AuthModalContext.Provider value={{ startAuthModal }}>{children}</AuthModalContext.Provider>
}

export default AuthModalProvider
